var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5, _path5, _g6, _g7, _path6, _g8, _g9, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCozabrac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "0aa6f3a382"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f8c095707"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 97.914062 91.535156 L 277.085938 91.535156 L 277.085938 270.710938 L 97.914062 270.710938 Z M 97.914062 91.535156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ea68b6f5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 91.535156 C 138.023438 91.535156 97.914062 131.644531 97.914062 181.121094 C 97.914062 230.601562 138.023438 270.710938 187.5 270.710938 C 236.976562 270.710938 277.085938 230.601562 277.085938 181.121094 C 277.085938 131.644531 236.976562 91.535156 187.5 91.535156 Z M 187.5 91.535156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec8d14f124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133 140 L 227 140 L 227 258 L 133 258 Z M 133 140 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "55b446defd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133.355469 148.816406 L 137.890625 176.957031 C 137.890625 176.957031 147.410156 182.441406 151.5 186.050781 C 155.828125 189.867188 159.304688 194.566406 162.84375 199.125 C 166.304688 203.585938 169.855469 208.054688 172.484375 213.050781 C 175.832031 219.417969 177.125 226.699219 180.136719 233.230469 C 182.855469 239.117188 185.472656 245.199219 189.496094 250.285156 C 191.863281 253.28125 198 257.957031 198 257.957031 L 226.921875 252.273438 C 226.921875 252.273438 218.917969 249.398438 215.011719 247.726562 C 211.164062 246.078125 207.011719 244.851562 203.671875 242.324219 C 198.648438 238.523438 194.554688 233.453125 191.195312 228.113281 C 187.472656 222.1875 185.878906 215.15625 182.972656 208.789062 C 179.300781 200.734375 175.996094 192.445312 171.347656 184.914062 C 167.34375 178.417969 161.886719 172.9375 157.457031 166.722656 C 155.351562 163.769531 153.367188 160.730469 151.433594 157.65625 C 149.277344 154.226562 147.503906 150.550781 145.21875 147.207031 C 144.117188 145.59375 143.074219 143.878906 141.609375 142.585938 C 140.734375 141.808594 139.761719 140.929688 138.601562 140.777344 C 137.480469 140.628906 136.167969 140.9375 135.339844 141.710938 C 134.53125 142.46875 134.511719 143.773438 134.207031 144.839844 C 133.832031 146.140625 133.355469 148.816406 133.355469 148.816406 Z M 133.355469 148.816406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.0150076,
    gradientTransform: "matrix(93.565618, 0, 0, 117.217427, 133.356004, 140.739807)",
    y1: 0.0128449,
    x2: 0.941916,
    gradientUnits: "userSpaceOnUse",
    y2: 1.053415,
    id: "f50507c1a0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.09967%, 56.898499%, 37.298584%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.09967%, 56.898499%, 37.298584%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.15155%, 56.95343%, 37.356567%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.491821%, 57.304382%, 37.731934%)",
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.780212%, 57.601929%, 38.049316%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.067078%, 57.899475%, 38.366699%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.355469%, 58.197021%, 38.684082%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.642334%, 58.493042%, 39.001465%)",
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.930725%, 58.790588%, 39.318848%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.21759%, 59.088135%, 39.63623%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.504456%, 59.385681%, 39.953613%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.791321%, 59.681702%, 40.26947%)",
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.079712%, 59.979248%, 40.586853%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.366577%, 60.276794%, 40.904236%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.654968%, 60.574341%, 41.221619%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.941833%, 60.870361%, 41.539001%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.230225%, 61.167908%, 41.856384%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.51709%, 61.465454%, 42.172241%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.805481%, 61.763%, 42.489624%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.092346%, 62.059021%, 42.807007%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.380737%, 62.356567%, 43.12439%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.667603%, 62.652588%, 43.441772%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.955994%, 62.950134%, 43.759155%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.242859%, 63.247681%, 44.076538%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.53125%, 63.545227%, 44.393921%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.818115%, 63.841248%, 44.709778%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.10498%, 64.138794%, 45.027161%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.391846%, 64.43634%, 45.344543%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.680237%, 64.733887%, 45.661926%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.967102%, 65.029907%, 45.979309%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.255493%, 65.327454%, 46.296692%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.542358%, 65.625%, 46.612549%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.83075%, 65.922546%, 46.929932%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.117615%, 66.218567%, 47.247314%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.406006%, 66.516113%, 47.564697%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.692871%, 66.812134%, 47.88208%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.981262%, 67.10968%, 48.199463%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.268127%, 67.407227%, 48.516846%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.556519%, 67.704773%, 48.834229%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.843384%, 68.000793%, 49.150085%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.131775%, 68.29834%, 49.467468%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.41864%, 68.595886%, 49.784851%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.707031%, 68.893433%, 50.102234%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.993896%, 69.189453%, 50.419617%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.280762%, 69.487%, 50.737%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.567627%, 69.784546%, 51.052856%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.856018%, 70.082092%, 51.370239%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.142883%, 70.378113%, 51.687622%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.431274%, 70.675659%, 52.005005%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.71814%, 70.973206%, 52.322388%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.006531%, 71.270752%, 52.639771%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.293396%, 71.566772%, 52.955627%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.581787%, 71.864319%, 53.27301%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.868652%, 72.160339%, 53.590393%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.157043%, 72.457886%, 53.907776%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.443909%, 72.755432%, 54.225159%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.7323%, 73.052979%, 54.542542%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.019165%, 73.348999%, 54.859924%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.307556%, 73.646545%, 55.177307%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.594421%, 73.944092%, 55.493164%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.881287%, 74.241638%, 55.810547%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.168152%, 74.537659%, 56.12793%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.456543%, 74.835205%, 56.445312%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.743408%, 75.132751%, 56.762695%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.031799%, 75.430298%, 57.080078%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.318665%, 75.726318%, 57.395935%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.607056%, 76.023865%, 57.713318%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.893921%, 76.321411%, 58.030701%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.182312%, 76.618958%, 58.348083%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.469177%, 76.914978%, 58.665466%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.757568%, 77.212524%, 58.982849%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.044434%, 77.508545%, 59.300232%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.332825%, 77.806091%, 59.617615%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.61969%, 78.103638%, 59.933472%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.908081%, 78.401184%, 60.250854%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.194946%, 78.697205%, 60.568237%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.481812%, 78.994751%, 60.88562%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.768677%, 79.292297%, 61.203003%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.057068%, 79.589844%, 61.520386%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.343933%, 79.885864%, 61.836243%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.632324%, 80.183411%, 62.153625%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.919189%, 80.480957%, 62.471008%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.207581%, 80.778503%, 62.788391%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.494446%, 81.074524%, 63.105774%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.782837%, 81.37207%, 63.423157%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.069702%, 81.669617%, 63.74054%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.358093%, 81.967163%, 64.057922%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.644958%, 82.263184%, 64.373779%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.93335%, 82.56073%, 64.691162%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.220215%, 82.85675%, 65.008545%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.508606%, 83.154297%, 65.325928%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.795471%, 83.451843%, 65.643311%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.083862%, 83.74939%, 65.960693%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.370728%, 84.04541%, 66.27655%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.657593%, 84.342957%, 66.593933%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.944458%, 84.640503%, 66.911316%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.232849%, 84.938049%, 67.228699%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.519714%, 85.23407%, 67.546082%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.808105%, 85.531616%, 67.863464%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.094971%, 85.829163%, 68.180847%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.383362%, 86.126709%, 68.49823%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.670227%, 86.422729%, 68.814087%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.958618%, 86.720276%, 69.13147%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.245483%, 87.017822%, 69.448853%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.533875%, 87.315369%, 69.766235%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.82074%, 87.611389%, 70.083618%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.109131%, 87.908936%, 70.401001%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.395996%, 88.204956%, 70.716858%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.684387%, 88.502502%, 71.034241%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.971252%, 88.800049%, 71.351624%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.258118%, 89.097595%, 71.669006%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.544983%, 89.393616%, 71.986389%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.833374%, 89.691162%, 72.303772%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.120239%, 89.988708%, 72.621155%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.40863%, 90.286255%, 72.938538%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.695496%, 90.582275%, 73.254395%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.983887%, 90.879822%, 73.571777%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.855713%, 90.72876%, 73.414612%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.625305%, 90.461731%, 73.13385%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.420837%, 90.228271%, 72.888184%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.214844%, 89.994812%, 72.642517%)",
    offset: 0.521177
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.11261%, 89.878845%, 72.520447%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.00885%, 89.761353%, 72.396851%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.802856%, 89.527893%, 72.151184%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.596863%, 89.294434%, 71.905518%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.392395%, 89.060974%, 71.659851%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.186401%, 88.827515%, 71.414185%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.980408%, 88.594055%, 71.166992%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.774414%, 88.360596%, 70.921326%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.569946%, 88.12561%, 70.675659%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.363953%, 87.892151%, 70.429993%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.157959%, 87.658691%, 70.184326%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.951965%, 87.425232%, 69.93866%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.747498%, 87.191772%, 69.692993%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.541504%, 86.958313%, 69.447327%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.33551%, 86.724854%, 69.20166%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.129517%, 86.491394%, 68.955994%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.925049%, 86.257935%, 68.710327%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.719055%, 86.024475%, 68.464661%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.513062%, 85.791016%, 68.218994%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.307068%, 85.557556%, 67.973328%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.1026%, 85.324097%, 67.727661%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.896606%, 85.090637%, 67.481995%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.690613%, 84.857178%, 67.236328%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.484619%, 84.623718%, 66.990662%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.278625%, 84.390259%, 66.744995%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.074158%, 84.156799%, 66.499329%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.868164%, 83.92334%, 66.253662%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.66217%, 83.68988%, 66.007996%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.456177%, 83.456421%, 65.762329%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.251709%, 83.222961%, 65.516663%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.045715%, 82.989502%, 65.270996%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.839722%, 82.756042%, 65.02533%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.633728%, 82.522583%, 64.779663%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.42926%, 82.289124%, 64.533997%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.223267%, 82.055664%, 64.28833%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.017273%, 81.822205%, 64.042664%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.811279%, 81.587219%, 63.796997%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.606812%, 81.35376%, 63.551331%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.400818%, 81.1203%, 63.305664%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.194824%, 80.886841%, 63.058472%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.988831%, 80.653381%, 62.812805%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.782837%, 80.419922%, 62.567139%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.578369%, 80.186462%, 62.321472%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.372375%, 79.953003%, 62.075806%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.166382%, 79.719543%, 61.830139%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.960388%, 79.486084%, 61.584473%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.75592%, 79.252625%, 61.338806%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.549927%, 79.019165%, 61.09314%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.343933%, 78.785706%, 60.847473%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.137939%, 78.552246%, 60.601807%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.933472%, 78.318787%, 60.35614%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.727478%, 78.085327%, 60.110474%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.461975%, 77.783203%, 59.793091%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.298706%, 77.598572%, 59.599304%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54efa8b387"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 129 139.199219 L 231 139.199219 L 231 262 L 129 262 Z M 129 139.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.788061,
    gradientTransform: "matrix(131.746707, 0, 0, 164.653522, 29.420006, 8.563483)",
    y1: -0.118539,
    x2: 0.149372,
    gradientUnits: "userSpaceOnUse",
    y2: 1.084362,
    id: "24a82be39e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.299805%, 0%, 0%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.299805%, 0%, 0%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.299805%, 0%, 0%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.299805%, 0%, 0%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.366943%, 0.488281%, 0.326538%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.434082%, 0.976562%, 0.653076%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.505798%, 1.498413%, 1.002502%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.579041%, 2.020264%, 1.351929%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.650757%, 2.542114%, 1.699829%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.723999%, 3.063965%, 2.049255%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.795715%, 3.585815%, 2.398682%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.868958%, 4.107666%, 2.748108%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.940674%, 4.629517%, 3.096008%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.01239%, 5.151367%, 3.445435%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.084106%, 5.673218%, 3.794861%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.157349%, 6.195068%, 4.144287%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.229065%, 6.716919%, 4.492188%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.302307%, 7.23877%, 4.841614%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.374023%, 7.76062%, 5.19104%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.447266%, 8.283997%, 5.540466%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.518982%, 8.805847%, 5.889893%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.590698%, 9.327698%, 6.239319%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.662415%, 9.849548%, 6.587219%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.735657%, 10.371399%, 6.936646%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.807373%, 10.89325%, 7.286072%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.880615%, 11.4151%, 7.635498%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.952332%, 11.936951%, 7.983398%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.025574%, 12.458801%, 8.332825%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.09729%, 12.980652%, 8.682251%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.169006%, 13.502502%, 9.031677%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.240723%, 14.024353%, 9.381104%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.313965%, 14.546204%, 9.73053%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.385681%, 15.068054%, 10.07843%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.458923%, 15.589905%, 10.427856%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.53064%, 16.111755%, 10.777283%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.603882%, 16.633606%, 11.126709%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.675598%, 17.155457%, 11.474609%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.747314%, 17.677307%, 11.824036%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.819031%, 18.199158%, 12.173462%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.892273%, 18.721008%, 12.522888%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.963989%, 19.242859%, 12.870789%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.037231%, 19.764709%, 13.220215%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.108948%, 20.28656%, 13.569641%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.18219%, 20.808411%, 13.919067%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.253906%, 21.330261%, 14.268494%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.325623%, 21.852112%, 14.61792%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.397339%, 22.373962%, 14.96582%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.470581%, 22.895813%, 15.315247%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.542297%, 23.417664%, 15.664673%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.61554%, 23.939514%, 16.014099%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.687256%, 24.461365%, 16.362%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.760498%, 24.983215%, 16.711426%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.832214%, 25.505066%, 17.060852%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.903931%, 26.028442%, 17.410278%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.975647%, 26.550293%, 17.759705%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.048889%, 27.072144%, 18.109131%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.120605%, 27.593994%, 18.457031%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.193848%, 28.115845%, 18.806458%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.265564%, 28.637695%, 19.155884%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.338806%, 29.159546%, 19.50531%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.410522%, 29.681396%, 19.85321%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.482239%, 30.203247%, 20.202637%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.553955%, 30.725098%, 20.552063%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.627197%, 31.246948%, 20.901489%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.698914%, 31.768799%, 21.24939%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.772156%, 32.290649%, 21.598816%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.843872%, 32.8125%, 21.948242%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.917114%, 33.334351%, 22.297668%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.988831%, 33.856201%, 22.647095%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.060547%, 34.378052%, 22.996521%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.132263%, 34.899902%, 23.344421%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.205505%, 35.421753%, 23.693848%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.277222%, 35.943604%, 24.043274%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.350464%, 36.465454%, 24.3927%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.42218%, 36.987305%, 24.740601%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.495422%, 37.509155%, 25.090027%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.567139%, 38.031006%, 25.439453%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.638855%, 38.552856%, 25.788879%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.710571%, 39.074707%, 26.13678%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.783813%, 39.596558%, 26.486206%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.85553%, 40.118408%, 26.835632%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.928772%, 40.640259%, 27.185059%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.000488%, 41.162109%, 27.534485%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.07373%, 41.68396%, 27.883911%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.145447%, 42.205811%, 28.231812%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.217163%, 42.729187%, 28.581238%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.288879%, 43.251038%, 28.930664%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.362122%, 43.772888%, 29.28009%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.433838%, 44.294739%, 29.627991%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.50708%, 44.816589%, 29.977417%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.578796%, 45.33844%, 30.326843%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.652039%, 45.860291%, 30.67627%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.723755%, 46.382141%, 31.025696%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.795471%, 46.903992%, 31.375122%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.867188%, 47.425842%, 31.723022%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.94043%, 47.947693%, 32.072449%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.012146%, 48.469543%, 32.421875%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.085388%, 48.991394%, 32.771301%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.157104%, 49.513245%, 33.119202%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.230347%, 50.035095%, 33.468628%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.302063%, 50.556946%, 33.818054%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.373779%, 51.078796%, 34.16748%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.445496%, 51.600647%, 34.515381%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.518738%, 52.122498%, 34.864807%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.590454%, 52.644348%, 35.214233%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.663696%, 53.166199%, 35.56366%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.735413%, 53.688049%, 35.913086%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.808655%, 54.2099%, 36.262512%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.880371%, 54.73175%, 36.610413%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.952087%, 55.253601%, 36.959839%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.023804%, 55.775452%, 37.309265%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.097046%, 56.297302%, 37.658691%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.168762%, 56.819153%, 38.006592%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.242004%, 57.341003%, 38.356018%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.313721%, 57.862854%, 38.705444%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.386963%, 58.384705%, 39.054871%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.44342%, 58.792114%, 39.326477%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 0.65306
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 59.199524%, 39.599609%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7246cb91c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 135 143 L 260 143 L 260 275 L 135 275 Z M 135 143 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "287e44a693"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143.855469 143.660156 L 136.765625 151.535156 C 130.890625 152.421875 146.648438 155.628906 136.886719 155.628906 L 175.902344 237.71875 L 259.59375 274.316406 C 259.707031 273.773438 259.726562 273.140625 259.703125 272.515625 C 259.738281 271.488281 259.597656 270.371094 259.414062 269.578125 C 258.5625 265.847656 258.03125 263.070312 255.085938 260.636719 C 251.5 257.667969 247.046875 255.875 242.746094 254.09375 C 238.269531 252.242188 233.308594 251.753906 228.855469 249.84375 C 226.363281 248.777344 224.464844 246.175781 221.773438 245.863281 C 219.753906 245.625 217.792969 246.160156 215.847656 246.910156 C 215.710938 246.851562 215.511719 246.765625 215.382812 246.707031 C 211.535156 245.058594 207.382812 243.828125 204.042969 241.300781 C 199.015625 237.503906 194.925781 232.445312 191.570312 227.109375 C 187.84375 221.183594 186.261719 214.144531 183.359375 207.777344 C 179.6875 199.722656 176.375 191.4375 171.730469 183.90625 C 167.722656 177.410156 162.265625 171.921875 157.835938 165.707031 C 155.730469 162.753906 153.753906 159.722656 151.820312 156.652344 C 149.664062 153.222656 147.894531 149.542969 145.609375 146.195312 C 145.035156 145.359375 144.464844 144.480469 143.855469 143.660156 Z M 143.855469 143.660156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 151,
    xlinkHref: "data:image/png;base64,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",
    id: "f951e55e9b",
    height: 139,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "43eac0539f"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#0aa6f3a382)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 151,
    xlinkHref: "data:image/png;base64,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",
    height: 139,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "212a0ba1ed"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 151,
    y: 0,
    height: 139
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "5b1306dfdc",
    patternUnits: "userSpaceOnUse",
    width: 151,
    patternTransform: "matrix(1, 0, 0, -1, 112.000002, 278.039973)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 151 139",
    height: 139,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#212a0ba1ed)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#43eac0539f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -194.500006,
    width: 540.000013,
    fill: "#550000",
    height: 540,
    y: -179.46002,
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "823a859d08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143 181 L 188 181 L 188 248 L 143 248 Z M 143 181 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6829acd2f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143.449219 181.96875 C 142.363281 183.421875 160.378906 198.742188 167.109375 208.5 C 170.867188 213.945312 174.511719 223.539062 178.332031 231.222656 C 183.050781 240.714844 187.59375 247.890625 187.59375 247.890625 C 187.59375 247.890625 183.492188 239.972656 179.34375 230.367188 C 176.167969 223.007812 173.375 214.367188 169.917969 209.300781 C 162.757812 198.828125 143.453125 181.96875 143.453125 181.96875 Z M 143.449219 181.96875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 151,
    xlinkHref: "data:image/png;base64,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",
    id: "692723f3be",
    height: 139,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5efdee4729"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#0aa6f3a382)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 151,
    xlinkHref: "data:image/png;base64,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",
    height: 139,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "de3c1f2b40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 151,
    y: 0,
    height: 139
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "925ad8955d",
    patternUnits: "userSpaceOnUse",
    width: 151,
    patternTransform: "matrix(1, 0, 0, -1, 112.000002, 278.039973)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 151 139",
    height: 139,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de3c1f2b40)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#5efdee4729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -194.500006,
    width: 540.000013,
    fill: "#d38d5f",
    height: 540,
    y: -179.46002,
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ddd5860e2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.011719 140 L 261 140 L 261 277 L 112.011719 277 Z M 112.011719 140 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ecea64c2d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159 267 L 262.761719 267 L 262.761719 277.949219 L 159 277.949219 Z M 159 267 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3f0605926b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127 267 L 135 267 L 135 272 L 127 272 Z M 127 267 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe43ac92bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.71875 267.675781 L 134.335938 267.273438 L 134.738281 271.292969 L 127.117188 271.496094 Z M 127.71875 267.675781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -6.97497e-7,
    gradientTransform: "matrix(7.618954, 0, 0, 4.220877, 127.119088, 267.274624)",
    y1: 0.5,
    x2: 0.999999,
    gradientUnits: "userSpaceOnUse",
    y2: 0.5,
    id: "a726851717"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 10.198975%, 10.198975%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.430908%, 10.430908%, 10.430908%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.664368%, 10.664368%, 10.664368%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.896301%, 10.896301%, 10.896301%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.129761%, 11.129761%, 11.129761%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.36322%, 11.36322%, 11.36322%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.59668%, 11.59668%, 11.59668%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.828613%, 11.828613%, 11.828613%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.062073%, 12.062073%, 12.062073%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.294006%, 12.294006%, 12.294006%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.527466%, 12.527466%, 12.527466%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.759399%, 12.759399%, 12.759399%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.992859%, 12.992859%, 12.992859%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.224792%, 13.224792%, 13.224792%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.458252%, 13.458252%, 13.458252%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.690186%, 13.690186%, 13.690186%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.923645%, 13.923645%, 13.923645%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.157104%, 14.157104%, 14.157104%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.390564%, 14.390564%, 14.390564%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.622498%, 14.622498%, 14.622498%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.855957%, 14.855957%, 14.855957%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.087891%, 15.087891%, 15.087891%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.32135%, 15.32135%, 15.32135%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.553284%, 15.553284%, 15.553284%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.786743%, 15.786743%, 15.786743%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.018677%, 16.018677%, 16.018677%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.252136%, 16.252136%, 16.252136%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.48407%, 16.48407%, 16.48407%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.717529%, 16.717529%, 16.717529%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.949463%, 16.949463%, 16.949463%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.182922%, 17.182922%, 17.182922%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.416382%, 17.416382%, 17.416382%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.649841%, 17.649841%, 17.649841%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.881775%, 17.881775%, 17.881775%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.115234%, 18.115234%, 18.115234%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.347168%, 18.347168%, 18.347168%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.580627%, 18.580627%, 18.580627%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.812561%, 18.812561%, 18.812561%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.046021%, 19.046021%, 19.046021%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.277954%, 19.277954%, 19.277954%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.511414%, 19.511414%, 19.511414%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.743347%, 19.743347%, 19.743347%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.976807%, 19.976807%, 19.976807%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.20874%, 20.20874%, 20.20874%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.4422%, 20.4422%, 20.4422%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.675659%, 20.675659%, 20.675659%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.909119%, 20.909119%, 20.909119%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.141052%, 21.141052%, 21.141052%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.374512%, 21.374512%, 21.374512%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.606445%, 21.606445%, 21.606445%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.839905%, 21.839905%, 21.839905%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.071838%, 22.071838%, 22.071838%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.305298%, 22.305298%, 22.305298%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.537231%, 22.537231%, 22.537231%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.770691%, 22.770691%, 22.770691%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.002625%, 23.002625%, 23.002625%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.236084%, 23.236084%, 23.236084%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.469543%, 23.469543%, 23.469543%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.703003%, 23.703003%, 23.703003%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.934937%, 23.934937%, 23.934937%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.168396%, 24.168396%, 24.168396%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.40033%, 24.40033%, 24.40033%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.633789%, 24.633789%, 24.633789%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.865723%, 24.865723%, 24.865723%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.099182%, 25.099182%, 25.099182%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.331116%, 25.331116%, 25.331116%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.564575%, 25.564575%, 25.564575%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.796509%, 25.796509%, 25.796509%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.029968%, 26.029968%, 26.029968%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.261902%, 26.261902%, 26.261902%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.495361%, 26.495361%, 26.495361%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.728821%, 26.728821%, 26.728821%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.96228%, 26.96228%, 26.96228%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.194214%, 27.194214%, 27.194214%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.427673%, 27.427673%, 27.427673%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.659607%, 27.659607%, 27.659607%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.893066%, 27.893066%, 27.893066%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.125%, 28.125%, 28.125%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.358459%, 28.358459%, 28.358459%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.590393%, 28.590393%, 28.590393%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.823853%, 28.823853%, 28.823853%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.055786%, 29.055786%, 29.055786%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.289246%, 29.289246%, 29.289246%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.522705%, 29.522705%, 29.522705%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.756165%, 29.756165%, 29.756165%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.988098%, 29.988098%, 29.988098%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.221558%, 30.221558%, 30.221558%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.453491%, 30.453491%, 30.453491%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.686951%, 30.686951%, 30.686951%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.918884%, 30.918884%, 30.918884%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.152344%, 31.152344%, 31.152344%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.384277%, 31.384277%, 31.384277%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.617737%, 31.617737%, 31.617737%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.84967%, 31.84967%, 31.84967%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.08313%, 32.08313%, 32.08313%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.315063%, 32.315063%, 32.315063%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.548523%, 32.548523%, 32.548523%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.781982%, 32.781982%, 32.781982%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.015442%, 33.015442%, 33.015442%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.247375%, 33.247375%, 33.247375%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.480835%, 33.480835%, 33.480835%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.712769%, 33.712769%, 33.712769%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.946228%, 33.946228%, 33.946228%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.178162%, 34.178162%, 34.178162%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.411621%, 34.411621%, 34.411621%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.643555%, 34.643555%, 34.643555%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.877014%, 34.877014%, 34.877014%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.108948%, 35.108948%, 35.108948%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.342407%, 35.342407%, 35.342407%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.575867%, 35.575867%, 35.575867%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.809326%, 35.809326%, 35.809326%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.04126%, 36.04126%, 36.04126%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.274719%, 36.274719%, 36.274719%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.506653%, 36.506653%, 36.506653%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.740112%, 36.740112%, 36.740112%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.972046%, 36.972046%, 36.972046%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.205505%, 37.205505%, 37.205505%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.437439%, 37.437439%, 37.437439%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.670898%, 37.670898%, 37.670898%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.902832%, 37.902832%, 37.902832%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.136292%, 38.136292%, 38.136292%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.368225%, 38.368225%, 38.368225%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.601685%, 38.601685%, 38.601685%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.835144%, 38.835144%, 38.835144%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.068604%, 39.068604%, 39.068604%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.300537%, 39.300537%, 39.300537%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.533997%, 39.533997%, 39.533997%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.76593%, 39.76593%, 39.76593%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.99939%, 39.99939%, 39.99939%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.76593%, 39.76593%, 39.76593%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.533997%, 39.533997%, 39.533997%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.300537%, 39.300537%, 39.300537%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.068604%, 39.068604%, 39.068604%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.835144%, 38.835144%, 38.835144%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.601685%, 38.601685%, 38.601685%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.368225%, 38.368225%, 38.368225%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.136292%, 38.136292%, 38.136292%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.902832%, 37.902832%, 37.902832%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.670898%, 37.670898%, 37.670898%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.437439%, 37.437439%, 37.437439%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.205505%, 37.205505%, 37.205505%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.972046%, 36.972046%, 36.972046%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.740112%, 36.740112%, 36.740112%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.506653%, 36.506653%, 36.506653%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.274719%, 36.274719%, 36.274719%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.04126%, 36.04126%, 36.04126%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.809326%, 35.809326%, 35.809326%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.575867%, 35.575867%, 35.575867%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.342407%, 35.342407%, 35.342407%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.108948%, 35.108948%, 35.108948%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.877014%, 34.877014%, 34.877014%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.643555%, 34.643555%, 34.643555%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.411621%, 34.411621%, 34.411621%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.178162%, 34.178162%, 34.178162%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.946228%, 33.946228%, 33.946228%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.712769%, 33.712769%, 33.712769%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.480835%, 33.480835%, 33.480835%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.247375%, 33.247375%, 33.247375%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.015442%, 33.015442%, 33.015442%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.781982%, 32.781982%, 32.781982%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.548523%, 32.548523%, 32.548523%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.315063%, 32.315063%, 32.315063%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.08313%, 32.08313%, 32.08313%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.84967%, 31.84967%, 31.84967%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.617737%, 31.617737%, 31.617737%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.384277%, 31.384277%, 31.384277%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.152344%, 31.152344%, 31.152344%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.918884%, 30.918884%, 30.918884%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.686951%, 30.686951%, 30.686951%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.453491%, 30.453491%, 30.453491%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.221558%, 30.221558%, 30.221558%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.988098%, 29.988098%, 29.988098%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.756165%, 29.756165%, 29.756165%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.522705%, 29.522705%, 29.522705%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.289246%, 29.289246%, 29.289246%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.055786%, 29.055786%, 29.055786%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.823853%, 28.823853%, 28.823853%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.590393%, 28.590393%, 28.590393%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.358459%, 28.358459%, 28.358459%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.125%, 28.125%, 28.125%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.893066%, 27.893066%, 27.893066%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.659607%, 27.659607%, 27.659607%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.427673%, 27.427673%, 27.427673%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.194214%, 27.194214%, 27.194214%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.96228%, 26.96228%, 26.96228%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.728821%, 26.728821%, 26.728821%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.496887%, 26.496887%, 26.496887%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.263428%, 26.263428%, 26.263428%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.029968%, 26.029968%, 26.029968%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.796509%, 25.796509%, 25.796509%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.564575%, 25.564575%, 25.564575%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.331116%, 25.331116%, 25.331116%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.099182%, 25.099182%, 25.099182%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.865723%, 24.865723%, 24.865723%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.633789%, 24.633789%, 24.633789%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.40033%, 24.40033%, 24.40033%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.168396%, 24.168396%, 24.168396%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.934937%, 23.934937%, 23.934937%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.703003%, 23.703003%, 23.703003%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.469543%, 23.469543%, 23.469543%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.236084%, 23.236084%, 23.236084%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.002625%, 23.002625%, 23.002625%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.770691%, 22.770691%, 22.770691%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.537231%, 22.537231%, 22.537231%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.305298%, 22.305298%, 22.305298%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.071838%, 22.071838%, 22.071838%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.839905%, 21.839905%, 21.839905%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.606445%, 21.606445%, 21.606445%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.374512%, 21.374512%, 21.374512%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.141052%, 21.141052%, 21.141052%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.909119%, 20.909119%, 20.909119%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.675659%, 20.675659%, 20.675659%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.443726%, 20.443726%, 20.443726%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.210266%, 20.210266%, 20.210266%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.976807%, 19.976807%, 19.976807%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.743347%, 19.743347%, 19.743347%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.511414%, 19.511414%, 19.511414%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.277954%, 19.277954%, 19.277954%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.046021%, 19.046021%, 19.046021%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.812561%, 18.812561%, 18.812561%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.580627%, 18.580627%, 18.580627%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.347168%, 18.347168%, 18.347168%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.115234%, 18.115234%, 18.115234%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.881775%, 17.881775%, 17.881775%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.649841%, 17.649841%, 17.649841%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.416382%, 17.416382%, 17.416382%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.182922%, 17.182922%, 17.182922%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.949463%, 16.949463%, 16.949463%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.717529%, 16.717529%, 16.717529%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.48407%, 16.48407%, 16.48407%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.252136%, 16.252136%, 16.252136%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.018677%, 16.018677%, 16.018677%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.786743%, 15.786743%, 15.786743%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.553284%, 15.553284%, 15.553284%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.32135%, 15.32135%, 15.32135%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.087891%, 15.087891%, 15.087891%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.855957%, 14.855957%, 14.855957%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.622498%, 14.622498%, 14.622498%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.390564%, 14.390564%, 14.390564%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.157104%, 14.157104%, 14.157104%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.923645%, 13.923645%, 13.923645%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.690186%, 13.690186%, 13.690186%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.458252%, 13.458252%, 13.458252%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.224792%, 13.224792%, 13.224792%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.992859%, 12.992859%, 12.992859%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.759399%, 12.759399%, 12.759399%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.527466%, 12.527466%, 12.527466%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.294006%, 12.294006%, 12.294006%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.062073%, 12.062073%, 12.062073%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.828613%, 11.828613%, 11.828613%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.59668%, 11.59668%, 11.59668%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.36322%, 11.36322%, 11.36322%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.131287%, 11.131287%, 11.131287%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.897827%, 10.897827%, 10.897827%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.664368%, 10.664368%, 10.664368%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.430908%, 10.430908%, 10.430908%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.198975%, 10.198975%, 10.198975%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b06760325e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113 139.199219 L 145 139.199219 L 145 198 L 113 198 Z M 113 139.199219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "021d49efca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 158 246 L 262.761719 246 L 262.761719 277 L 158 277 Z M 158 246 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f8c095707)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ea68b6f5a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aa5464",
    d: "M 97.914062 91.535156 L 277.085938 91.535156 L 277.085938 270.710938 L 97.914062 270.710938 Z M 97.914062 91.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec8d14f124)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55b446defd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f50507c1a0)",
    d: "M 133.355469 140.628906 L 133.355469 257.957031 L 226.921875 257.957031 L 226.921875 140.628906 Z M 133.355469 140.628906 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54efa8b387)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.710193, 0, 0, 0.711904, 112.462116, 134.643433)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 29.419252 19.908558 L 35.805058 59.437263 C 35.805058 59.437263 49.209201 67.14108 54.967977 72.211114 C 61.062269 77.571961 65.957504 84.172882 70.940743 90.576268 C 75.813977 96.842479 80.813716 103.119663 84.515394 110.1376 C 89.22912 119.08149 91.049707 129.30935 95.290411 138.483697 C 99.118594 146.752681 102.803771 155.296017 108.469042 162.440155 C 111.802202 166.648722 120.443117 173.21672 120.443117 173.21672 L 161.167069 165.233063 C 161.167069 165.233063 149.897029 161.194595 144.396765 158.846138 C 138.979005 156.530603 133.132225 154.807669 128.4295 151.257548 C 121.35616 145.918649 115.591884 138.796459 110.861657 131.295662 C 105.619906 122.971808 103.375798 113.095119 99.283602 104.151229 C 94.113354 92.836933 89.460131 81.193414 82.914817 70.614382 C 77.277047 61.489419 69.593178 53.791089 63.355879 45.061193 C 60.391237 40.912984 57.597103 36.644059 54.874473 32.325751 C 51.838327 27.508122 49.341207 22.344808 46.123553 17.647894 C 44.572479 15.381743 43.103908 12.972928 41.041309 11.156715 C 39.80925 10.064792 38.439685 8.830206 36.806106 8.616211 C 35.227531 8.407703 33.379442 8.84118 32.213386 9.927615 C 31.074831 10.992103 31.04733 12.824778 30.61831 14.322742 C 30.090284 16.14993 29.419252 19.908558 29.419252 19.908558 Z M 29.419252 19.908558 ",
    stroke: "url(#24a82be39e)",
    strokeWidth: 1,
    strokeMiterlimit: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7246cb91c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#287e44a693)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5b1306dfdc)",
    d: "M 130.890625 143.660156 L 259.738281 143.660156 L 259.738281 274.316406 L 130.890625 274.316406 Z M 130.890625 143.660156 ",
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaaaa",
    d: "M 135.835938 168.4375 L 158.515625 249.722656 L 198.777344 258.816406 L 178.363281 218.460938 L 157.949219 175.828125 Z M 135.835938 168.4375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaaaa",
    d: "M 130.65625 207.363281 L 129.808594 267.332031 L 133.917969 267.617188 C 133.917969 267.617188 133.40625 254.132812 134.058594 247.4375 C 134.652344 241.390625 135.96875 235.421875 137.460938 229.53125 C 138.074219 227.121094 139.117188 224.835938 139.730469 222.425781 C 141.210938 216.636719 144.445312 219.441406 144.550781 217.027344 C 144.671875 214.1875 141.734375 211.886719 139.449219 210.207031 C 138.074219 209.195312 136.25 209.019531 134.628906 208.5 C 133.316406 208.082031 134.363281 208.007812 130.65625 207.363281 Z M 130.65625 207.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f7f7f",
    d: "M 133.355469 149.53125 L 137.890625 177.667969 C 137.890625 177.667969 147.410156 183.152344 151.5 186.761719 C 155.828125 190.578125 159.304688 195.277344 162.84375 199.835938 C 166.304688 204.296875 169.855469 208.765625 172.484375 213.761719 C 175.832031 220.128906 177.125 227.410156 180.136719 233.941406 C 182.855469 239.832031 185.472656 245.914062 189.496094 250.996094 C 191.863281 253.992188 198 258.667969 198 258.667969 L 226.921875 252.984375 C 226.921875 252.984375 218.917969 250.109375 215.011719 248.4375 C 211.164062 246.789062 207.011719 245.5625 203.671875 243.039062 C 198.648438 239.238281 194.554688 234.164062 191.195312 228.828125 C 187.472656 222.902344 185.878906 215.871094 182.972656 209.5 C 179.300781 201.445312 175.996094 193.15625 171.347656 185.625 C 167.34375 179.128906 161.886719 173.648438 157.457031 167.433594 C 155.351562 164.480469 153.367188 161.441406 151.433594 158.371094 C 149.277344 154.9375 147.503906 151.265625 145.21875 147.917969 C 144.117188 146.304688 143.074219 144.589844 141.609375 143.296875 C 140.734375 142.519531 139.761719 141.640625 138.601562 141.488281 C 137.480469 141.339844 136.167969 141.652344 135.339844 142.425781 C 134.53125 143.179688 134.511719 144.484375 134.207031 145.550781 C 133.832031 146.855469 133.355469 149.53125 133.355469 149.53125 Z M 133.355469 149.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    d: "M 117.203125 183.234375 C 117.203125 183.234375 116.171875 187.558594 116.621094 188.460938 C 119.453125 194.179688 121.53125 199 123.21875 204.132812 C 125.386719 210.730469 127.371094 217.421875 128.597656 224.253906 C 129.5 229.28125 129.851562 234.402344 130.035156 239.503906 C 130.246094 245.398438 129.984375 251.304688 129.632812 257.191406 C 129.386719 261.355469 128.429688 269.652344 128.429688 269.652344 L 133.953125 269.339844 C 133.953125 269.339844 133.480469 245.421875 133.734375 233.464844 C 133.863281 227.457031 134.613281 218.371094 134.613281 215.460938 C 134.613281 214.742188 135.550781 213.371094 136.476562 212.8125 C 137.851562 211.976562 141.261719 212.171875 141.261719 212.171875 L 130.835938 185.242188 Z M 117.203125 183.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#823a859d08)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6829acd2f6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#925ad8955d)",
    d: "M 142.363281 181.96875 L 187.589844 181.96875 L 187.589844 247.886719 L 142.363281 247.886719 Z M 142.363281 181.96875 ",
    fillRule: "nonzero"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbcec6",
    d: "M 145.339844 195.070312 C 145.339844 195.070312 152.410156 203.503906 154.964844 208.335938 C 157.359375 212.863281 160.175781 222.804688 160.175781 222.804688 L 164.1875 222.804688 C 164.1875 222.804688 161.164062 212.847656 158.664062 208.335938 C 155.894531 203.335938 148.332031 194.667969 148.332031 194.667969 Z M 145.339844 195.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ddd5860e2c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    d: "M 160.570312 271.316406 C 162.113281 272.773438 164.191406 273.648438 166.234375 274.21875 C 177.078125 277.253906 188.667969 276.269531 199.917969 276.632812 C 219.421875 277.261719 236.308594 277.039062 258.460938 276.230469 C 260.445312 276.15625 260.183594 272.480469 259.753906 270.601562 C 258.902344 266.871094 255.519531 264.089844 252.574219 261.652344 C 248.988281 258.683594 244.539062 256.894531 240.242188 255.113281 C 235.765625 253.261719 230.804688 252.757812 226.347656 250.851562 C 223.859375 249.785156 221.949219 247.1875 219.261719 246.871094 C 215.160156 246.394531 211.308594 249.09375 207.351562 250.28125 C 204.03125 251.28125 200.851562 252.84375 197.429688 253.410156 C 193.324219 254.089844 189.082031 254.191406 184.953125 253.691406 C 180.777344 253.191406 176.511719 252.335938 172.761719 250.421875 C 169.617188 248.820312 166.929688 246.347656 164.539062 243.746094 C 162.835938 241.890625 161.488281 239.707031 160.285156 237.492188 C 157.492188 232.347656 155.328125 226.851562 153.480469 221.292969 C 151.386719 214.992188 150.082031 208.453125 148.660156 201.964844 C 147.464844 196.503906 146.726562 190.949219 145.542969 185.480469 C 143.097656 174.1875 140.941406 162.773438 137.324219 151.800781 C 136.40625 149.019531 134.292969 146.605469 133.917969 143.703125 C 133.832031 143.039062 133.773438 142.226562 134.199219 141.710938 C 134.582031 141.253906 135.304688 141.109375 135.902344 141.144531 C 137.253906 141.21875 139.253906 143.410156 139.589844 142.847656 C 139.589844 142.847656 136.734375 139.945312 135.761719 140.007812 C 132.296875 140.234375 129.332031 143.515625 126.828125 146.117188 C 123.570312 149.503906 121.535156 153.910156 119.316406 158.054688 C 116.863281 162.632812 114.0625 167.195312 112.9375 172.265625 C 112.269531 175.273438 112.546875 178.433594 112.796875 181.503906 C 112.945312 183.375 112.808594 185.445312 113.789062 187.046875 C 115.039062 189.101562 117.699219 189.851562 119.523438 191.421875 C 123.964844 195.25 128.324219 199.230469 132.152344 203.679688 C 135.035156 207.03125 137.714844 210.609375 139.871094 214.472656 C 142.371094 218.957031 144.058594 223.859375 145.824219 228.683594 C 147.875 234.277344 149.558594 240.007812 151.210938 245.734375 C 152.351562 249.6875 153.140625 253.738281 154.332031 257.671875 C 155.085938 260.167969 155.789062 262.695312 156.882812 265.0625 C 157.898438 267.257812 158.808594 269.65625 160.570312 271.316406 Z M 160.570312 271.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ecea64c2d2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 159.878906 267.667969 C 160.617188 269.269531 161.4375 270.839844 162.699219 272.03125 C 164.242188 273.488281 166.3125 274.371094 168.359375 274.945312 C 179.199219 277.976562 190.796875 276.984375 202.046875 277.347656 C 221.550781 277.976562 238.445312 277.753906 260.59375 276.945312 C 261.933594 276.898438 262.238281 275.210938 262.171875 273.542969 C 262.121094 274.945312 261.738281 276.191406 260.59375 276.234375 C 238.445312 277.042969 221.550781 277.265625 202.046875 276.636719 C 190.796875 276.273438 179.199219 277.265625 168.359375 274.234375 C 166.3125 273.660156 164.242188 272.777344 162.699219 271.316406 C 161.625 270.304688 160.871094 269.019531 160.210938 267.667969 Z M 159.878906 267.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#800000",
    d: "M 114.648438 177.054688 C 114.636719 178.773438 114.777344 180.511719 114.914062 182.214844 C 115.066406 184.085938 114.9375 186.152344 115.914062 187.753906 C 117.167969 189.808594 119.839844 190.570312 121.664062 192.136719 C 126.105469 195.964844 130.460938 199.949219 134.289062 204.394531 C 136.726562 207.226562 136.871094 207.367188 138.816406 210.558594 L 139.261719 210.558594 C 137.222656 207.097656 136.910156 206.726562 134.289062 203.683594 C 130.460938 199.234375 126.105469 195.253906 121.664062 191.425781 C 119.839844 189.855469 117.167969 189.097656 115.914062 187.042969 C 114.9375 185.441406 115.066406 183.375 114.914062 181.503906 C 114.796875 180.035156 114.675781 178.539062 114.648438 177.054688 Z M 114.648438 177.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3f0605926b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe43ac92bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a726851717)",
    d: "M 127.117188 267.273438 L 127.117188 271.496094 L 134.738281 271.496094 L 134.738281 267.273438 Z M 127.117188 267.273438 ",
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b06760325e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    d: "M 137.1875 139.292969 C 133.722656 139.519531 130.746094 142.8125 128.242188 145.410156 C 124.984375 148.796875 122.960938 153.191406 120.742188 157.335938 C 118.289062 161.914062 115.476562 166.480469 114.351562 171.550781 C 113.683594 174.558594 113.96875 177.714844 114.214844 180.785156 C 114.367188 182.65625 114.238281 184.722656 115.214844 186.324219 C 116.46875 188.378906 119.121094 189.136719 120.941406 190.707031 C 123.367188 192.796875 125.765625 194.929688 128.066406 197.160156 L 144.933594 175.222656 C 143.191406 167.089844 141.34375 158.972656 138.742188 151.085938 C 137.824219 148.304688 135.71875 145.894531 135.34375 142.988281 C 135.257812 142.324219 135.183594 141.523438 135.609375 141.007812 C 135.992188 140.546875 136.722656 140.394531 137.320312 140.429688 C 138.671875 140.503906 140.671875 142.703125 141.003906 142.140625 C 141.003906 142.140625 138.160156 139.230469 137.1875 139.296875 Z M 137.1875 139.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#021d49efca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    d: "M 220.632812 246.8125 C 216.816406 246.71875 213.199219 249.167969 209.488281 250.28125 C 206.167969 251.28125 202.96875 252.832031 199.546875 253.394531 C 195.441406 254.074219 191.203125 254.183594 187.074219 253.683594 C 185.84375 253.539062 184.621094 253.355469 183.390625 253.128906 L 158.3125 263.363281 C 158.53125 263.933594 158.765625 264.5 159.023438 265.054688 C 160.035156 267.25 160.945312 269.644531 162.707031 271.304688 C 164.25 272.761719 166.320312 273.648438 168.367188 274.21875 C 179.207031 277.25 190.804688 276.257812 202.054688 276.621094 C 221.558594 277.253906 238.429688 277.027344 260.578125 276.222656 C 262.566406 276.148438 262.316406 272.46875 261.890625 270.59375 C 261.035156 266.859375 257.644531 264.085938 254.699219 261.648438 C 251.113281 258.683594 246.679688 256.886719 242.378906 255.109375 C 237.90625 253.253906 232.941406 252.746094 228.488281 250.835938 C 225.996094 249.769531 224.074219 247.191406 221.386719 246.878906 C 221.128906 246.847656 220.886719 246.816406 220.632812 246.8125 Z M 220.632812 246.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCozabrac);
export default __webpack_public_path__ + "static/media/cozabrac.84d520110b9a06a62cd6f89f918f2232.svg";
export { ForwardRef as ReactComponent };